import type { DocPageContent } from '../docs-content'

const page = {
  order: 6,
  slug: 'timeline',
  title: '基本时间线编辑',
  description: '轨道、片段、选择、修剪、标记、缩放和撤销。',
  category: '核心编辑',
  sections: [
    {
      title: '时间线结构',
      items: [
        '视频轨道容纳视频、图片、文本、形状、字幕和调整层等视觉元素。',
        '音频轨道容纳音频片段和来自视频文件的关联音频。',
        '标记、入/出点、吸附和缩放控件分布在时间线表面周围。',
      ],
    },
    {
      title: '基本编辑',
      items: [
        '将片段从媒体面板拖到轨道上。',
        '使用选择和关联选择来同时或分别移动视频和音频。',
        '在播放头或光标处分割片段。',
        '当相邻片段段可以重新连接时进行合并。',
        '使用"删除"移除片段，使用"波纹删除"封闭间隙。',
      ],
    },
    {
      title: '导航与安全',
      items: [
        '在需要或不需要精确定位时切换吸附功能。',
        '添加标记用于编辑备注和时间参考。',
        '设置入/出点用于范围相关工作流程。',
        '使用时间线缩放检查密集编辑而不改变片段时间。',
        '对时间线操作使用撤销和重做。',
      ],
    },
  ],
} satisfies DocPageContent

export default page